'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import claimCoupon from '@/actions/byMember/claimCoupon';
import { useGlobalContext } from '@/providers/GlobalContextProvider';
import { PageLoadingSpinner } from '@/components/LoadingSpinner';

/**
 * 這是個自動取得 coupon 的頁面
 * 取叫 /taiwan-mobile 是為了討好台灣大哥大
 */

/**
 * FIXME: 這邊原本使用 next/navigation 的 redirect 寫
 * 但是跳轉後會造成 hook 觸發有問題
 * 不知道 next.js 什麼時候會解決這個問題
 * 只能暫時使用 client side solution 解決
 *
 * 在 @/app/page.js 也有同樣問題
 */

export default function Page({ searchParams }) {
  const router = useRouter();
  const { member } = useGlobalContext();

  useEffect(() => {
    const redirect = async () => {
      const { couponCode, utm_source, utm_medium, utm_campaign } = searchParams;

      const nextSearchParams = new URLSearchParams();
      nextSearchParams.append('utm_source', utm_source);
      nextSearchParams.append('utm_medium', utm_medium);
      nextSearchParams.append('utm_campaign', utm_campaign);

      if (!member) {
        nextSearchParams.append('forward', 'taiwan-mobile');
        nextSearchParams.append('couponCode', couponCode);
        return router.replace(`/login?${nextSearchParams.toString()}`);
      }

      const payload = new FormData();
      payload.append('code', couponCode);
      payload.append('business_unit', 'ugo');

      const { success, error } = await claimCoupon(payload, false);

      if (success) {
        nextSearchParams.append('success', '優惠券領取成功！');
      } else {
        nextSearchParams.append('error', error);
      }

      return router.replace(`/coupon?${nextSearchParams.toString()}`);
    };

    redirect();
  }, []);

  return <PageLoadingSpinner />;
}
